import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
interface BonusProps {
  number: string;
  title: string;
  image: string;
  description: string;
  value: string;
}
export function BonusCard({
  number,
  title,
  image,
  description,
  value
}: BonusProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} whileHover={{
    y: -10
  }} className="bg-white border-2 border-blue-100 rounded-3xl overflow-hidden flex flex-col shadow-lg hover:shadow-2xl hover:border-blue-200 transition-all duration-300 relative group" data-id="element-184">
      <div className="absolute top-4 right-4 z-20" data-id="element-185">
        <motion.div animate={{
        scale: [1, 1.1, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="bg-blue-600 text-white p-2 rounded-full shadow-lg" data-id="element-186">
          <Gift size={16} data-id="element-187" />
        </motion.div>
      </div>

      <div className="aspect-[4/3] overflow-hidden bg-blue-50 relative" data-id="element-188">
        <img src={image} alt={title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-189" />
        <div className="absolute inset-0 bg-gradient-to-t from-blue-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-190" />
      </div>

      <div className="p-8 flex-grow flex flex-col relative" data-id="element-191">
        <div className="flex items-center gap-2 mb-3" data-id="element-192">
          <span className="bg-blue-100 text-blue-600 font-black text-[10px] px-3 py-1 rounded-full uppercase tracking-widest" data-id="element-193">
            BONO {number}
          </span>
          <Sparkles size={14} className="text-yellow-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-194" />
        </div>

        <h3 className="text-xl font-black text-blue-950 mb-4 leading-tight group-hover:text-blue-600 transition-colors" data-id="element-195">
          {title}
        </h3>
        <p className="text-blue-800/70 text-sm mb-6 flex-grow" data-id="element-196">{description}</p>
        <div className="pt-4 border-t border-blue-50" data-id="element-197">
          <p className="text-blue-300 text-xs line-through" data-id="element-198">
            VALORADO EN {value}
          </p>
          <p className="text-blue-600 font-black text-lg" data-id="element-199">HOY GRATIS</p>
        </div>
      </div>
    </motion.div>;
}